import { useRuntimeConfig } from "nuxt/app";
import type { RuntimeConfig } from "nuxt/schema";

export const usePublicConfig = (): RuntimeConfig["public"] => {
  const config = useRuntimeConfig();
  return config.public;
};
